// extracted by mini-css-extract-plugin
export var content = "_2x-3";
export var contentWrapper = "_2x-2";
export var fullWidthButton = "_2x-4";
export var heroImage = "_2x-6";
export var logo = "_2x-1";
export var logoContainer = "_2x-0";
export var panel = "_2x-5";